import React from 'react'
import { Button } from 'semantic-ui-react'
import { buttonStyles } from '.'

const ButtonCustomIcon = props => {
  const { text, icon, ...rest } = props

  return (
    <Button type='button' inverted color='grey' style={buttonStyles.buttonWithCustomIconStyle} {...rest}>
      {icon}
      <span style={{ marginLeft: '1.188rem' }}>{text}</span>
    </Button>
  )
}

export default ButtonCustomIcon
